import styled from 'styled-components'

export default styled.h1`
	color: #ff206e;
	font-weight: 900;
	font-family: "Ubuntu", sans-serif;
	font-size: 40px;
`
